import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { CustomOrderApiParameter, CustomOrderService } from "@tSurya/Services/SendCustomOrder";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type SubmitCustomSubmitOrder = HasOnSuccess & CustomOrderApiParameter & HasOnError;

type CustomHandlerType = ApiHandlerDiscreteParameter<SubmitCustomSubmitOrder, CustomOrderApiParameter, any>;

type HandlerType = ApiHandler<
CustomOrderApiParameter & HasOnSuccess<CustomOrderApiParameter>,
CustomOrderApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await CustomOrderService(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];


const submitCustomOrder = createHandlerChainRunner(chain, "submitCustomOrder");
export default submitCustomOrder;
